import axios from "axios";

import ConnUrls from '../Connections/ConnectURL'

const getRests = async () => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "rest");
    return (dFromF.data);
}

const getRestById = async (id,obj) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "rest/" + id,obj);
    return (dFromF.data);
}

const updateRest = async (id, obj) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "rest/updat/" + id, obj);
    return (dFromF.data);
}

const deleteRest = async (id) => {
    let dFromF = await axios.delete(ConnUrls.ApiUrl + "rest/" + id);
    return (dFromF);
}

const createRest = async (obj) => {
    let dFromF = await axios.post(ConnUrls.ApiUrl + "rest", obj);
    return (dFromF.data);
}

const getClearRest = async () => {

    let dFromF = await axios.get(ConnUrls.ApiUrl + "rest/newFile");

    return (dFromF.data);
}

const getRestsListSmall = async (obj) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "rest/lstRest",obj);
    return (dFromF.data);
}


const updaterestStatus = async (restId, stat,token) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "rest/statUpdate/" + restId, {stat,token});
    return (dFromF.data);
}


const updaterestUrl = async (restId, stat,token) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "rest/updaterstUrl/" + restId, {stat,token});
    return (dFromF.data);
}


const updaterestCRType = async (restId, CRT,token) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "rest/updateCRT/" + restId, { CRT,token });
    return (dFromF.data);
}



export default {
    getRests,
    getRestById,
    updateRest,
    deleteRest,
    createRest,
    getClearRest,
    getRestsListSmall,
    updaterestStatus,
    updaterestCRType,
    updaterestUrl

};